module.exports = __webpack_public_path__ + "static/media/savio10.eba7e36c.jpg";